import {
  createContext,
  FunctionComponent,
  PropsWithChildren,
  useContext,
  useMemo,
} from 'react';
import { useDomainSelection } from '../DomainSelectionContext';

const StripeKeyContext = createContext('');

export const useStripeKey = () => useContext(StripeKeyContext);

export const { Provider } = StripeKeyContext;

type StripeKeyProviderProps = PropsWithChildren<{
  publishableKeys: {
    row: string;
    us: string;
  };
}>;

export const StripeKeyProvider: FunctionComponent<StripeKeyProviderProps> = ({
  children,
  publishableKeys,
}) => {
  const { currentAccessibeAccount } = useDomainSelection();

  const stripeKey = useMemo(() => {
    const row = publishableKeys.row;
    const us = publishableKeys.us;

    if (currentAccessibeAccount?.billingRegion === 'US') {
      return us;
    }
    return row;
  }, [
    currentAccessibeAccount?.billingRegion,
    publishableKeys.row,
    publishableKeys.us,
  ]);

  return (
    <StripeKeyContext.Provider value={stripeKey}>
      {children}
    </StripeKeyContext.Provider>
  );
};
